import {POST} from "@/services/gateway";

const listUsers = ({pagination, search, filter, module}) => {
  return POST('google/user/list', {pagination, search, filter, module});
}

export {
  listUsers,
}
